<template>
    <PageHeader :title="(form.updateStatus) ? sprintf($t('pages.ecommerce.product.editProductPattern'), [data.name ?? '']) : $t('pages.ecommerce.product.newProduct')" back-to="/ecommerce/product"/>

    <el-tabs v-model="tabModel" class="product-tabs">
        <el-tab-pane :label="$t('pages.ecommerce.product.save.tabs.general')" name="general">
            <el-form :model="form.data" ref="dataForm">
                <div class="row g-6 mb-6 g-xl-9 mb-xl-9 unset-position-card">
                    <div class="col-md-9">

                        <div class="card mb-5">
                            <div class="card-header border-bottom-dashed align-items-center" data-bs-toggle="collapse" data-bs-target="#generalCardBody">
                                <h4 class="card-title">
                                    {{ $t('pages.ecommerce.product.save.generalCardTitle') }}
                                </h4>

                                <div>
                                    <span class="svg-icon svg-icon-1">
                                        <i class="bi bi-caret-down-fill icon-down"></i>
                                        <i class="bi bi-caret-up-fill icon-up"></i>
                                    </span>
                                </div>
                            </div>
                            <div class="card-body px-9 pt-4 collapse show" id="generalCardBody">
                                <div class="row">

                                    <div class="col-md-6 col-lg-6">
                                        <div class="fv-row mb-1 mt-3">
                                            <label class="required fs-6 fw-bold mb-2">{{ $t('pages.ecommerce.product.cols.name') }}</label>
                                            <el-form-item prop="name" :rules="$validation.getMessage(['required'])">
                                                <el-input v-model="form.data.name" type="text"/>
                                            </el-form-item>
                                        </div>
                                    </div>

                                    <div class="col-md-6 col-lg-6">
                                        <div class="fv-row mb-1 mt-3">
                                            <label class="fs-6 fw-bold mb-2">{{ $t('pages.ecommerce.product.cols.code') }}</label>
                                            <el-form-item prop="code">
                                                <el-input v-model="form.data.code" type="text" :readonly="this.form.updateStatus">
                                                    <template #suffix>
                                                        <span class="input-action" v-if="!this.form.data.id" @click="generateCode">
                                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.5 20.7259C14.6 21.2259 14.2 21.826 13.7 21.926C13.2 22.026 12.6 22.0259 12.1 22.0259C9.5 22.0259 6.9 21.0259 5 19.1259C1.4 15.5259 1.09998 9.72592 4.29998 5.82592L5.70001 7.22595C3.30001 10.3259 3.59999 14.8259 6.39999 17.7259C8.19999 19.5259 10.8 20.426 13.4 19.926C13.9 19.826 14.4 20.2259 14.5 20.7259ZM18.4 16.8259L19.8 18.2259C22.9 14.3259 22.7 8.52593 19 4.92593C16.7 2.62593 13.5 1.62594 10.3 2.12594C9.79998 2.22594 9.4 2.72595 9.5 3.22595C9.6 3.72595 10.1 4.12594 10.6 4.02594C13.1 3.62594 15.7 4.42595 17.6 6.22595C20.5 9.22595 20.7 13.7259 18.4 16.8259Z" fill="black"/><path opacity="0.3" d="M2 3.62592H7C7.6 3.62592 8 4.02592 8 4.62592V9.62589L2 3.62592ZM16 14.4259V19.4259C16 20.0259 16.4 20.4259 17 20.4259H22L16 14.4259Z" fill="black"/></svg>
                                                        </span>

                                                        <span class="input-action" v-if="this.form.data.id" @click="copyCode">
                                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.5" d="M18 2H9C7.34315 2 6 3.34315 6 5H8C8 4.44772 8.44772 4 9 4H18C18.5523 4 19 4.44772 19 5V16C19 16.5523 18.5523 17 18 17V19C19.6569 19 21 17.6569 21 16V5C21 3.34315 19.6569 2 18 2Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M14.7857 7.125H6.21429C5.62255 7.125 5.14286 7.6007 5.14286 8.1875V18.8125C5.14286 19.3993 5.62255 19.875 6.21429 19.875H14.7857C15.3774 19.875 15.8571 19.3993 15.8571 18.8125V8.1875C15.8571 7.6007 15.3774 7.125 14.7857 7.125ZM6.21429 5C4.43908 5 3 6.42709 3 8.1875V18.8125C3 20.5729 4.43909 22 6.21429 22H14.7857C16.5609 22 18 20.5729 18 18.8125V8.1875C18 6.42709 16.5609 5 14.7857 5H6.21429Z" fill="black"/></svg>
                                                        </span>
                                                    </template>
                                                </el-input>
                                            </el-form-item>
                                        </div>
                                    </div>

                                    <div class="col-md-12 col-lg-12">
                                        <div class="fv-row mb-1 mt-3">
                                            <label class="fs-6 fw-bold mb-2">{{ $t('pages.ecommerce.product.cols.description') }}</label>
                                            <el-form-item prop="description">
                                                <el-input v-model="form.data.description" type="textarea" rows="3"/>
                                            </el-form-item>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="col-md-3">
                        <div class="sticky-card">
                            <div class="card">
                                <div class="card-body">
                                    <div class="fv-row mb-1 mt-3">
                                        <label class="required fs-6 fw-bold mb-2">{{ $t('pages.ecommerce.product.cols.product_type') }}</label>
                                        <el-form-item prop="product_type_id" :rules="$validation.getMessage(['required'])">
                                            <el-select v-model="form.data.product_type_id" :disabled="form.updateStatus" class="w-100" :placeholder="$t('common.chooseSelect')">
                                                <el-option :value="1" :label="$t('pages.ecommerce.product.types[0]')"></el-option>
                                                <el-option :value="2" :label="$t('pages.ecommerce.product.types[1]')"></el-option>
                                                <el-option :value="3" :label="$t('pages.ecommerce.product.types[2]')"></el-option>
                                                <el-option :value="4" :label="$t('pages.ecommerce.product.types[3]')"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>

                                    <div class="fv-row mb-1 mt-3">
                                        <label class="required fs-6 fw-bold mb-2">{{ $t('pages.ecommerce.product.cols.target_type') }}</label>
                                        <el-form-item prop="target_type" :rules="$validation.getMessage(['required'])">
                                            <el-select v-model="form.data.target_type" :disabled="form.updateStatus" class="w-100" :placeholder="$t('common.chooseSelect')">
                                                <el-option value="COMPANY" :label="$t('common.company')"></el-option>
                                                <el-option value="CUSTOMER" :label="$t('common.customer')"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>

                                    <div class="fv-row mb-1 mt-3">
                                        <label class="required fs-6 fw-bold mb-2">{{ $t('pages.ecommerce.product.cols.is_stackable') }}</label>
                                        <el-form-item prop="is_stackable" :rules="$validation.getMessage(['required'])">
                                            <el-select v-model="form.data.is_stackable" class="w-100" :placeholder="$t('common.chooseSelect')">
                                                <el-option :value="true" :label="$t('common.yes')"></el-option>
                                                <el-option :value="false" :label="$t('common.no')"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>

                                    <div class="fv-row mb-1 mt-3">
                                        <label class="required fs-6 fw-bold mb-2">{{ $t('common.status') }}</label>
                                        <el-form-item prop="active" :rules="$validation.getMessage(['required'])">
                                            <el-radio-group v-model="form.data.active" text-color="#fff" fill="#0C2C55">
                                                <el-radio-button :label="$t('common.active')" :value="true"/>
                                                <el-radio-button :label="$t('common.passive')" :value="false"/>
                                            </el-radio-group>
                                        </el-form-item>
                                    </div>

                                    <div class="fv-row mb-1 mt-3">
                                        <label class="required fs-6 fw-bold mb-2">{{ $t('common.sort') }}</label>
                                        <el-form-item prop="sort" :rules="$validation.getMessage(['required'])">
                                            <el-input-number v-model="form.data.sort" :min="1"/>
                                        </el-form-item>
                                    </div>
                                </div>
                            </div>

                            <div class="fv-row mt-5">
                                <el-form-item class="mb-0">
                                    <button @click.prevent="onSubmit" :data-kt-indicator="form.loading ? 'on' : null" class="btn btn-lg btn-primary w-100" type="button">
                                        <span v-if="!form.loading" class="indicator-label">{{ $t("btn.save") }}</span>
                                        <span v-if="form.loading" class="indicator-progress">
                                            {{ $t("messages.wait") }}
                                            <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                        </span>
                                    </button>
                                </el-form-item>
                            </div>
                        </div>
                    </div>
                </div>
            </el-form>
        </el-tab-pane>

        <el-tab-pane v-if="form.updateStatus" :label="$t('pages.ecommerce.product.save.tabs.prices')" name="prices">
            <custom-table
                :title="$t('pages.ecommerce.product.save.priceCardTitle')"
                rowKey="id"
                :items="form.data?.prices || []"
                :loading="false"
                selectableRows
                :columns="fields.price"
                :actions="priceActions"
                @action="handlePriceAction"
                @selectableRows="handlePriceSelectedRow">
                <template v-slot:period_type="{ row: record }">
                    {{ record.period_type_id ? $t('pages.ecommerce.product.price.periods[' + (record.period_type_id - 1) + ']') : $t('pages.ecommerce.product.price.is_recurring_oneshot') }}
                </template>
                <template v-slot:actions="{ row: record }">
                    <div class="d-flex justify-content-end">
                        <el-tooltip :content="$t('common.edit')" placement="top">
                            <a @click="fetchPrice(record)" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">
                                <span class="svg-icon svg-icon-3">
                                    <inline-svg src="/media/icons/duotune/art/art005.svg"/>
                                </span>
                            </a>
                        </el-tooltip>
                        <a @click="deletePrice(record)" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm">
                            <span class="svg-icon svg-icon-3">
                                <inline-svg src="/media/icons/duotune/general/gen027.svg"/>
                            </span>
                        </a>
                    </div>
                </template>
            </custom-table>
        </el-tab-pane>

        <el-tab-pane v-if="form.updateStatus" :label="$t('pages.ecommerce.product.save.tabs.modules')" name="modules">
            <ProductModule v-if="tabModel === 'modules'" :productID="form.data.id"/>
        </el-tab-pane>

        <el-tab-pane v-if="form.updateStatus" :label="$t('pages.ecommerce.product.save.tabs.resources')" name="resources">
            <ProductResource v-if="tabModel === 'resources'" :productID="form.data.id"/>
        </el-tab-pane>

        <el-tab-pane v-if="form.updateStatus" :label="$t('pages.ecommerce.product.save.tabs.dependencies')" name="dependencies">
            <ProductDependency v-if="tabModel === 'dependencies'" :productID="form.data.id"/>
        </el-tab-pane>

        <el-tab-pane v-if="form.updateStatus && form.data.product_type_id === 1" :label="$t('pages.ecommerce.product.save.tabs.upgrade_paths')" name="upgrade_paths">
            <ProductUpgradePath v-if="tabModel === 'upgrade_paths'" :productID="form.data.id"/>
        </el-tab-pane>
    </el-tabs>

    <div class="modal fade" id="kt_modal_price" ref="priceModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered mw-650px">
            <div class="modal-content">
                <div class="modal-header" id="kt_modal_price_header">
                    <h2 class="fw-bolder">{{ price.title }}</h2>
                    <div id="kt_modal_price_close" data-bs-dismiss="modal"
                         class="btn btn-icon btn-sm btn-active-icon-primary">
                        <span class="svg-icon svg-icon-1">
                            <inline-svg src="/media/icons/duotune/arrows/arr061.svg"/>
                        </span>
                    </div>
                </div>
                <el-form @submit.prevent="priceSubmit()" :model="price.data" ref="priceForm">
                    <div class="modal-body py-10 px-lg-17">
                        <div class="scroll-y me-n7 pe-7 row" id="kt_modal_price_scroll" data-kt-scroll="true"
                             data-kt-scroll-activate="{default: false, lg: true}" data-kt-scroll-max-height="auto"
                             data-kt-scroll-dependencies="#kt_modal_price_header"
                             data-kt-scroll-wrappers="#kt_modal_price_scroll" data-kt-scroll-offset="300px">

                            <div class="fv-row mb-1 mt-3">
                                <label class="required fs-6 fw-bold mb-2">{{ $t('pages.ecommerce.product.price.is_recurring') }}</label>
                                <el-form-item>
                                    <el-select v-model="price.data.is_recurring" :disabled="price.updateStatus" class="w-100" :placeholder="$t('common.chooseSelect')">
                                        <el-option :value="true" :label="$t('pages.ecommerce.product.price.is_recurring_recurring')"></el-option>
                                        <el-option :value="false" :label="$t('pages.ecommerce.product.price.is_recurring_oneshot')"></el-option>
                                    </el-select>
                                </el-form-item>
                                <small class="text-muted d-block mt-1">{{ $t('pages.ecommerce.product.price.is_recurring_help') }}</small>
                            </div>

                            <div class="fv-row mb-1 mt-3" v-if="price.data.is_recurring">
                                <label class="required fs-6 fw-bold mb-2">{{ $t('pages.ecommerce.product.price.period_type') }}</label>
                                <el-form-item>
                                    <el-select v-model="price.data.period_type_id" :disabled="price.updateStatus" class="w-100" :placeholder="$t('common.chooseSelect')">
                                        <el-option :value="1" :label="$t('pages.ecommerce.product.price.periods[0]')"></el-option>
                                        <el-option :value="2" :label="$t('pages.ecommerce.product.price.periods[1]')"></el-option>
                                        <el-option :value="3" :label="$t('pages.ecommerce.product.price.periods[2]')"></el-option>
                                        <el-option :value="4" :label="$t('pages.ecommerce.product.price.periods[3]')"></el-option>
                                        <el-option :value="5" :label="$t('pages.ecommerce.product.price.periods[4]')"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>

                            <div class="fv-row mb-1 mt-3">
                                <label class="required fs-6 fw-bold mb-2">{{ $t('common.currency') }}</label>
                                <el-form-item>
                                    <el-select v-model="price.data.currency_id" :disabled="price.updateStatus" class="w-100" :placeholder="$t('common.chooseSelect')" filterable>
                                        <el-option v-for="(currency, currencyIndex) in this.$root.currencies" :key="currencyIndex"
                                                   :value="currency.id" :label="`${currency.code} - ${currency.name}`"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>

                            <div class="fv-row mb-1 mt-3">
                                <label class="required fs-6 fw-bold mb-2">{{ $t('pages.ecommerce.product.price.price') }}</label>
                                <el-form-item prop="price" :rules="$validation.getMessage(['required'])">
                                    <el-input v-model="price.data.price" oninput="value=value.replace(/[^0-9.]/g,'')"/>
                                </el-form-item>
                            </div>

                            <div class="fv-row mb-1">
                                <label class="fs-6 fw-bold mb-2">{{ $t('common.status') }}</label>
                                <el-form-item prop="active">
                                    <el-radio-group v-model="price.data.active">
                                        <el-radio-button :label="true">{{ $t("common.active") }}</el-radio-button>
                                        <el-radio-button :label="false">{{ $t("common.passive") }}</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer flex-center">
                        <button :data-kt-indicator="form.loading ? 'on' : null" class="btn btn-lg btn-primary"
                                type="submit" :disabled="form.loading">
                            <span v-if="!form.loading" class="indicator-label">{{ $t("btn.save") }}</span>
                            <span v-if="form.loading" class="indicator-progress">
                                {{ $t("messages.wait") }}
                                <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>
                    </div>
                </el-form>
            </div>
        </div>
    </div>


</template>

<script>
import PageHeader from "@/components/page-header/PageHeader.vue";
import CustomTable from "@/components/custom-table/index.vue";
import ProductModule from "@/components/ecommerce/product/module";
import ProductResource from "@/components/ecommerce/product/resource";
import ProductDependency from "@/components/ecommerce/product/dependency";
import ProductUpgradePath from "@/components/ecommerce/product/upgrade-path";

export default {
    name: "_id",
    components: {
        CustomTable,
        PageHeader,
        ProductModule,
        ProductResource,
        ProductDependency,
        ProductUpgradePath,
    },
    data() {
        return {
            tabModel: 'general',
            priceActions: [
                {name: "new", icon: "bi-plus-lg", label: "btn.add"},
                {name: "refresh", icon: "bi-arrow-repeat", label: "btn.refresh"},
                {name: "delete", icon: "bi-trash", label: "btn.delete"}
            ],
            selectedPriceRowKeys: [],
            fields: {
                price: [
                    {
                        name: this.$t("common.id"),
                        key: 'id',
                    },
                    {
                        name: this.$t("pages.ecommerce.product.price.period_type"),
                        scopedSlots: {customRender: "period_type"}
                    },
                    {
                        name: this.$t("pages.ecommerce.product.price.price"),
                        key: 'price',
                    },
                    {
                        name: this.$t("common.action"),
                        scopedSlots: {customRender: "actions"}
                    }
                ],
            },
            price: {
                title: '',
                loading: false,
                updateStatus: false,
                data: {},
            },
            data: {},
            form: {
                title: '',
                loading: false,
                updateStatus: false,
                data: {}
            },
            rules: {},
        }
    },
    computed: {
        itemID() {
            return this.$route.params.id;
        },
        save() {
            return this.$store.state.ecommerce.product.save.data;
        }
    },
    created() {
        this.resetForm();

        if (this.itemID && !(this.itemID > 0)) {
            this.$router.push({
                path: "/ecommerce/product",
            });
        }
    },
    mounted() {
        if (this.itemID && this.itemID > 0) {
            this.setCurrentPageBreadcrumbs(this.sprintf(this.$t('pages.ecommerce.product.editProduct'), [this.data.name ?? ""]), []);
            this.form.updateStatus = true;
            this.loadData();
        } else {
            this.setCurrentPageBreadcrumbs(this.$t('pages.ecommerce.product.newProduct'), []);
        }
    },
    watch: {
        itemID(newValue) {
            if (newValue && newValue > 0) {
                this.form.updateStatus = true;
                this.loadData(newValue);
                this.setCurrentPageBreadcrumbs(this.sprintf(this.$t('pages.ecommerce.product.editProduct'), [this.data.name ?? ""]), []);
            } else {
                this.resetForm();
                this.setCurrentPageBreadcrumbs(this.$t('pages.ecommerce.product.newProduct'), []);
            }
        }
    },
    methods: {
        async loadData(itemID = this.itemID) {
            this.$store.dispatch("ecommerce/product/show", {
                id: itemID
            }).then(() => {
                let data = this.save;
                this.form.loading = false;
                this.data = data;
                this.form.data = data;
            });
        },
        onSubmit() {
            this.$refs.dataForm.validate((valid) => {
                if (valid) {
                    this.form.loading = true;

                    if (this.form.updateStatus) {
                        this.$store.dispatch('ecommerce/product/update', {
                            id: this.form.data.id,
                            formData: this.form.data
                        }).then((response) => {
                            if (response?.status) {
                                this.onResponse(response, () => {
                                    let productID = response.data.id;
                                    this.loadData(productID);
                                });
                            }

                            this.form.loading = false;
                        });
                    } else {
                        this.$store.dispatch('ecommerce/product/add', {
                            formData: this.form.data
                        }).then((response) => {
                            if (response?.status) {
                                this.onResponse(response, () => {
                                    const productID = response.data.id;
                                    this.$router.push({
                                        path: "/ecommerce/product/save/" + productID
                                    });
                                });
                            }

                            this.form.loading = false;
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        priceSubmit() {
            this.$refs.priceForm.validate(async (valid) => {
                if (!valid) return false;

                if (!this.price.data.is_recurring) {
                    this.price.data.period_type_id = null;
                }

                const isDuplicate = (this.form.data.prices || []).some(p =>
                    p.id !== this.price.data.id
                    && p.period_type_id === this.price.data.period_type_id
                    && p.currency_id === this.price.data.currency_id
                );

                if (isDuplicate) {
                    this.$message.error(this.$t('pages.ecommerce.product.price.duplicate_period_currency'));
                    return;
                }

                this.price.loading = true;

                try {
                    const productId = this.form.data.id;
                    const response = this.price.updateStatus
                        ? await this.$store.dispatch('ecommerce/product/price/update', {
                            id: this.price.data.id,
                            product_id: productId,
                            formData: this.price.data
                        })
                        : await this.$store.dispatch('ecommerce/product/price/add', {
                            product_id: productId,
                            formData: this.price.data
                        });

                    if (response?.status) {
                        this.onResponse(response, () => {
                            this.hideModal(this.$refs.priceModal);
                            this.loadData();
                        });
                    }
                } finally {
                    this.price.loading = false;
                }
            });
        },
        fetchPrice(record) {
            this.resetPriceForm();
            this.price.updateStatus = true;
            const periodLabel = record.period_type_id
                ? this.$t('pages.ecommerce.product.price.periods[' + (record.period_type_id - 1) + ']')
                : this.$t('pages.ecommerce.product.price.is_recurring_oneshot');
            this.price.title = periodLabel + (record.currency?.code ? ' - ' + record.currency.code : '');
            this.price.data = {...record};

            this.showModal(this.$refs.priceModal);
        },
        addPrice() {
            this.resetPriceForm();
            this.price.updateStatus = false;
            this.price.title = this.$t('pages.ecommerce.product.save.newPriceCardTitle');
            this.showModal(this.$refs.priceModal);
        },
        handlePriceAction(name) {
            switch (name) {
                case "new":
                    this.addPrice();
                    break;
                case "refresh":
                    this.loadData();
                    break;
                case "delete":
                    this.bulkDeletePrices();
                    break;
            }
        },
        handlePriceSelectedRow(record) {
            this.selectedPriceRowKeys = record;
        },
        async bulkDeletePrices() {
            const ids = this.selectedPriceRowKeys.flat();
            if (!ids.length) {
                this.$message.warning(this.$t('messages.selectRow'));
                return;
            }
            for (const id of ids) {
                await this.$store.dispatch('ecommerce/product/price/delete', {
                    id: [id],
                    product_id: this.form.data.id
                });
            }
            this.selectedPriceRowKeys = [];
            this.loadData();
        },
        deletePrice(record) {
            this.eventBus.$emit('showConfirmDialog', {
                title: this.$t('btn.delete'),
                message: this.$t('messages.sureDelete'),
                confirmType: 'danger',
                onConfirm: async () => {
                    await this.$store.dispatch('ecommerce/product/price/delete', {
                        id: [record.id],
                        product_id: this.form.data.id
                    });
                    this.loadData();
                },
            });
        },
        resetForm() {
            this.tabModel = 'general';
            this.form.updateStatus = false;
            this.form.data = {
                code: null,
                name: null,
                description: null,
                product_type_id: 1,
                target_type: "COMPANY",
                is_stackable: false,
                sort: 1,
                active: true,
                prices: []
            };

            this.resetPriceForm();
        },
        resetPriceForm() {
            this.price = {
                updateStatus: false,
                data: {
                    period_type_id: 1,
                    is_recurring: true,
                    currency_id: 1,
                    price: null,
                    active: true
                }
            };
        },
        generateCode() {
            const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
            let code = '';

            for (let i = 0; i < 8; i++) {
                code += chars.charAt(Math.floor(Math.random() * chars.length));
            }

            this.form.data.code = `PRD-${code}`;
        },
        copyCode() {
            navigator.clipboard.writeText(this.form.data.code);
        },
        format(price) {
            const value = Number(price)

            if (isNaN(value)) {
                return '0,00'
            }

            return value.toLocaleString('tr-TR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })
        },
        startDateDisabled(date) {
            return date.getTime() < Date.now()
        },
        endDateDisabled(date) {
            return (date.getTime() < Date.now()) || (date.getTime() < new Date(this.form.data.usage_start_date).getTime())
        },
    }
}
</script>

<style>
.sticky-card {
    position: sticky;
    top: 140px;
}

.collapse-toggle {
    cursor: pointer;
}

.input-action {
    cursor: pointer;
    color: var(--bs-gray-500, #a1a5b7);
    display: flex;
    align-items: center;
    height: 100%;
    transition: color 0.15s;
}

.input-action:hover {
    color: var(--bs-danger, #f1416c);
}

.icon-up {
    display: none;
}

.card-header:not(.collapsed) .icon-up {
    display: inline;
}

.card-header:not(.collapsed) .icon-down {
    display: none;
}

.card-body.collapse .card {
    width: 100% !important;
}

.card-body.collapse .card-body {
    padding: 0 !important;
}
</style>